export enum coursesFastActionsFilterOptions {
  allCourses = 0,
  publishedCourses = 1,
  draftCourses = 2,
}
